import http from "@/api/http.js";

export function getRecoveryEmail(email) {
  return http.post(`/administrators/password_link`, { email }).then(res => {
    return res;
  });
}

export function updatePassword(token, password) {
  return http.post(`/administrators/restore_password`, { token, password });
}

export async function getOrdersStatus() {
  return await http.get("/sync");
}

export async function markOrderShippedApi(uuid) {
  return http.post(`/orders/update/${uuid}`, { order: { status: "shipped" } });
}

export async function reverifyProductsApi(uuid) {
  return http.get(`/orders/re_verify_stock_and_location/${uuid}`);
}

export function getOrders(filters, systemCode) {
  const newFilters = Object.entries(filters)
    .map(([key, val]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    })
    .join("&");
  return http.get(`/orders/set/${systemCode}?${newFilters}`).then(res => {
    return res.data;
  });
}
export function getSystems() {
  return http.get("/systems").then(res => {
    return res.data;
  });
}
export function getOrder(uuid) {
  return http.get(`/orders/single/${uuid}`).then(res => {
    return res.data;
  });
}
export function sendOrder(uuid, systemCode) {
  return http
    .get(`/sync/export_single_order/${uuid}/${systemCode}`)
    .then(res => {
      return res.data;
    });
}
export function sendAllPendingOrders(systemCode, marketplace) {
  const marketplaceURL = marketplace ? `?marketplace_code=${marketplace}` : "";
  return http
    .get(`/sync/export_new_orders/${systemCode}${marketplaceURL}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function forceSentToSystem(uuid, systemUUID) {
  return http.get(`/sync/force_sent/${uuid}/${systemUUID}`).then(res => {
    return res.data;
  });
}

export function updateOrder(uuid, newValues) {
  return http
    .post(`/orders/update/${uuid}`, { order: newValues })
    .then(res => {
      return res.data;
    })
    .catch(() => {
      return { status: "error", meessage: "order not updated" };
    });
}

// eslint-disable-next-line no-unused-vars
export function getShipments(filters) {
  return http
    .get("connector/shipments_pending_to_source")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function sendShipmentToShipstation(shipmentUUID) {
  return http
    .get(`connector/send_pending_shipments_to_source/${shipmentUUID}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function sendAllShipmentsToShipstation() {
  return http
    .get("connector/send_pending_shipments_to_source")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// eslint-disable-next-line no-unused-vars
export function uploaMamShippingFile(files) {
  // eslint-disable-next-line no-unused-vars
  // let promise = new Promise(function(resolve, reject) {
  //   window.setTimeout(function() {
  //     resolve({
  //       status: "success",
  //       totalShipmentsInserted: 10,
  //       originalResponse: {
  //         ordersUpdated: 10
  //       }
  //     });
  //   }, 5000);
  // });
  // return promise;
  const formData = new FormData();
  files.forEach(file => {
    formData.append("file[]", file);
  });
  return http
    .post("upload/shipments/mam", formData)
    .then(res => {
      // if (res.data.image) {}
      return res.data;
    })
    .catch(e => {
      return e;
    });
}

export function createQueryString(data) {
  return Object.keys(data)
    .map(key => {
      let val = data[key];
      if (val !== null && typeof val === "object") val = createQueryString(val);
      return `${key}=${encodeURIComponent(`${val}`.replace(/\s/g, "_"))}`;
    })
    .join("&");
}
